// @ts-ignore
import Textarea from 'react-textarea-autosize';
export default Textarea;
